import { render, staticRenderFns } from "./ReLeadStaffInfo.vue?vue&type=template&id=714f9074&scoped=true"
import script from "./ReLeadStaffInfo.vue?vue&type=script&lang=js"
export * from "./ReLeadStaffInfo.vue?vue&type=script&lang=js"
import style0 from "./ReLeadStaffInfo.vue?vue&type=style&index=0&id=714f9074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714f9074",
  null
  
)

export default component.exports